import { render, staticRenderFns } from "./BxAccountForm.vue?vue&type=template&id=068ac8c9&"
import script from "./BxAccountForm.vue?vue&type=script&lang=js&"
export * from "./BxAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports